var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconMetro = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E21E25",
  d: "M13.591 6c-.315 0-.59.203-.745.504l-2.38 4.637 1.25 2.434c.126.203.31.348.516.4.057.018.12.023.184.023h-.012.017c.316 0 .59-.202.746-.504l3.601-7.013a.883.883 0 0 1 .551-.452.937.937 0 0 1 .184-.023H13.59V6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#388AC1",
  d: "M8.694 13.975a.876.876 0 0 0 .516-.4l1.25-2.434-2.38-4.637c-.15-.295-.413-.492-.717-.504a.49.49 0 0 0-.16.023.89.89 0 0 0-.517.406c-.017.029-.906 1.75-1.279 2.48l2.352 4.585c.155.302.43.504.745.504h.006a.882.882 0 0 0 .184-.023Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#029F52",
  d: "M20.83 11.489s-2.541-4.927-2.564-4.979c-.155-.301-.43-.504-.746-.504h-.017c-.069-.006-.126.006-.184.017a.918.918 0 0 0-.55.452L15.553 8.84l2.168 4.214a1.722 1.722 0 0 0 2.34.742 1.749 1.749 0 0 0 .768-2.307Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FAE806",
  d: "M6.956 6H3.48c-.315 0-.59.203-.745.504L.17 11.49c-.402.852-.075 1.878.763 2.312a1.726 1.726 0 0 0 2.34-.742L5.24 9.234S6.663 6.47 6.686 6.43a.908.908 0 0 1 .516-.406A.638.638 0 0 1 7.386 6h-.43Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#952474",
  d: "M12.415 13.998a.664.664 0 0 1-.183-.023.859.859 0 0 1-.516-.4l-1.25-2.434-1.25 2.434a.875.875 0 0 1-.517.4.638.638 0 0 1-.184.024h3.9Z"
})));
export default SvgIconMetro;